import { render, staticRenderFns } from "./page-input.vue?vue&type=template&id=5aecb1aa&"
import script from "./page-input.vue?vue&type=script&lang=js&"
export * from "./page-input.vue?vue&type=script&lang=js&"
import style0 from "./page-input.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports